export interface UpdateLowerFieldsRequest {
  areaId: string;
  criteriaId: string;
  data: string; // new value for the field being updated (grade, tags, picklist selection, etc.)
  listData: string[];
  gradeProfileId: string;
  updateType: UpdateLowerFieldType;
}

export enum UpdateLowerFieldType
{
    UpdateGrade,
    UpdateTags,
    UpdatePicklist,
    UpdateDropdown,
    UpdatePerson
}